import { connect } from 'react-redux'
import values from 'lodash/values'

import { fetchMSDSSheets } from '../../actions/msds-sheets'

import MSDSSheetsList from '../../components/msds-sheets/msds-sheets-list'

function mapStateToProps (state, ownProps) {
  const msdsSheets = values(state.msdsSheets) || []

  return {
    msdsSheets
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchMSDSSheets())

  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MSDSSheetsList)



// WEBPACK FOOTER //
// ./src/containers/msds-sheets/msds-sheets-container.js